<template>
  <div class="container">
    <div class="card card-signin my-5">
      <div class="card-body">
          <h5><font-awesome-icon icon="user-lock" class="icon"/> Meu Perfil</h5>
          <br>
          <p>
            Você solicitou a revogação das informações concedidas, todavia sinta-se livre pra conectar-se em qualquer WIFI da rede WISPOT sempre que precisar.
          </p>  
          <p>Suporte WISPOT</p>  
      </div>
    </div>    
  </div>
</template>
<style scoped>
  .container{        
        max-width: 400px;
        min-width: 400px;
    }

    .logo{
        display: inline-block;
        width: 200px;
    }

    .card-signin {
        border: 0;
        border-radius: 1rem;
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
    }

    .card-signin .card-title {
        margin-bottom: 2rem;
        font-weight: 300;
        font-size: 1.5rem;
    }

    .card-signin .card-body {
        padding: 2rem;
    }
</style>
<script>

export default{
  data(){
    return {
      
    }
  },
  components: {        
    
  },
  mounted(){
    
  },
  methods:{
    
  },
  computed:{
    
  }
}
</script>